var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.21407C0 7.1835 0.489564 7.67791 1.44446 7.67791H3.07795V9.3114C3.07795 10.2663 3.57236 10.7559 4.54179 10.7559H6.21407C7.1835 10.7559 7.67791 10.2663 7.67791 9.3114V7.67791H9.30656C10.2614 7.67791 10.7559 7.1835 10.7559 6.21407V4.54179C10.7559 3.57721 10.2614 3.07795 9.30656 3.07795H7.67791V1.44446C7.67791 0.489564 7.1835 0 6.21407 0H4.54179C3.57236 0 3.07795 0.489564 3.07795 1.44446V3.07795H1.44446C0.489564 3.07795 0 3.57721 0 4.54179V6.21407ZM0.998516 6.11228V4.64843C0.998516 4.2752 1.18271 4.08616 1.56563 4.08616H4.08616V1.56079C4.08616 1.18271 4.2752 0.998516 4.64358 0.998516H6.11228C6.48066 0.998516 6.6697 1.18271 6.6697 1.56079V4.08616H9.19022C9.5683 4.08616 9.75734 4.2752 9.75734 4.64843V6.11228C9.75734 6.48551 9.5683 6.6697 9.19022 6.6697H6.6697V9.19507C6.6697 9.57315 6.48066 9.75734 6.11228 9.75734H4.64358C4.2752 9.75734 4.08616 9.57315 4.08616 9.19507V6.6697H1.56563C1.18271 6.6697 0.998516 6.48551 0.998516 6.11228Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC12);
export default __webpack_public_path__ + "static/media/c12.ad0b15fd58954d97ee1697f40f9af581.svg";
export { ForwardRef as ReactComponent };